export default "__VITE_ASSET__DP_chQnB__"